
import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';

/** @title Select with custom trigger text */
@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
})
export class MultiSelectComponent {
  toppings = new FormControl();

  toppingList: string[] = ['5698', '7823', '8523', '9874', '0025', '3695'];
}


